import pic1 from "../images/pic1.jpg";
import pic2 from "../images/pic2.jpg";
import pic3 from "../images/pic3.jpg";
import pic4 from "../images/pic4.jpg";
import pic5 from "../images/pic5.jpg";
import pic6 from "../images/pic6.jpg";

const photoArray = () => {
  return [pic1, pic2, pic3, pic4, pic5, pic6];
};

export default photoArray();
